import { Trans, t } from '@lingui/macro';
import { useGetIntroducerFundingRequirements } from 'lendingApi/lendingApiHooks';
import Skeleton from 'react-loading-skeleton';
import {
  deserialiseFundingRequirements,
  deserialiseRequiredLoanDocuments,
} from './fundingRequirements.helper';
import styles from './FundingRequirements.module.css';
import { FundingRequirementSection } from './FundingRequirementSection';

import 'react-loading-skeleton/dist/skeleton.css';

export const FundingRequirements = () => {
  const { data: fundingRequirements, isLoading: fundingRequirementsLoading } =
    useGetIntroducerFundingRequirements();

  const renderContents = () => {
    if (fundingRequirementsLoading || !fundingRequirements) {
      return (
        <div data-testid="funding-requirement-spinner">
          <div className={styles.spinnerGroup}>
            <Skeleton className={styles.spinner} width={180} height={24} />
            <Skeleton className={styles.buttonSpinner} width={24} height={24} />
          </div>
          <div className={styles.spinnerGroup}>
            <Skeleton className={styles.spinner} width={180} height={24} />
            <Skeleton className={styles.buttonSpinner} width={24} height={24} />
          </div>
        </div>
      );
    }

    return (
      <>
        <FundingRequirementSection
          title={t`Applicant’s details`}
          requirements={deserialiseFundingRequirements(
            fundingRequirements.data.funding_requirements,
          )}
        />
        <FundingRequirementSection
          title={t`Contracts`}
          requirements={deserialiseRequiredLoanDocuments(
            fundingRequirements.data.required_loan_documents,
          )}
        />
      </>
    );
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>
        <Trans>Funding steps details:</Trans>
      </h2>
      {renderContents()}
    </div>
  );
};
